/**
 * Determines if a user has admin privileges based on their role level
 * @param {number} role - The user's role level
 * @returns {boolean} - True if user has admin privileges, false otherwise
 */
export const getAdminStatus = (role) => {
    if (role > 40) return true;
    return false;
};

/**
 * Determines if a user is a subscriber based on their role level
 * @param {number} role - The user's role level
 * @returns {boolean} - True if user is a subscriber, false otherwise
 */
export const getSubscriberStatus = (role) => {
    if (role > 20) return true;
    return false;
}; 